import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tab-cmd-client-negoce',
  templateUrl: './tab-cmd-client-negoce.component.html',
  styleUrls: ['./tab-cmd-client-negoce.component.scss']
})
export class TabCmdClientNegoceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
